import React, { useEffect, useMemo, useRef } from "react"
import styles from "./WaitingToJoinScreenNew.module.scss"
import logger from '../../utils/logger';

const WaitingToJoinScreenNew = ({ visible = true, overlayType = "video", starCount = 150 }) => {
    const stars = useMemo(() => Array.from({ length: starCount }), [starCount])
    const videoRef = useRef(null)

    useEffect(() => {
        if (visible && overlayType === "video" && videoRef.current) {
            videoRef.current.currentTime = 0
            videoRef.current.play().catch(err => {
                logger("error", "Error playing video:", err)
            })
        }
    }, [visible, overlayType])

    if (overlayType === "video") {
        return (
            <div className={`${styles.videoContainer} ${!visible ? styles.hide : ""}`}>
                <video
                    ref={videoRef}
                    className={styles.video}
                    playsInline
                    preload="auto"
                    loop
                    autoPlay
                >
                    <source src="/video/videotheme2.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
        )
    }

    return (
        <div className={`${styles.spaceContainer} ${!visible ? styles.hide : ""}`}>
            {stars.map((_, idx) => (
                <div
                    key={idx}
                    className={styles.stars}
                    style={{
                        top: `${Math.random() * 100}vh`,
                        left: `-10px`,
                        animationDelay: `${Math.random() * 3}s`,
                    }}
                />
            ))}
        </div>
    )
}

export default WaitingToJoinScreenNew


